import Pet from '@assets/images/pet.png';
import Girl from '@assets/images/girl.png';
import Boy from '@assets/images/boy.png'
import Astronaut from '@assets/images/Astronant.png';
import Toy from '@assets/images/Toy.png';

export interface ICharacters {
  image: string;
  title: string;
}
export const characters: ICharacters[] = [
  {
    image: Girl,
    title: 'Girl',
  },
  {
    image: Boy,
    title: 'Boy',
  },
  {
    image: Astronaut,
    title: 'Astronaut',
  },
  {
    image: Pet,
    title: 'Pet',
  },
  {
    image: Toy,
    title: 'Toy',
  },
];
